import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "mr-3 font-normal" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "flex justify-center w-full" }, " Data tidak tersedia ", -1)
const _hoisted_6 = {
  key: 1,
  class: "text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, { class: "" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1),
            (_ctx.route.meta?.permission?.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: _ctx.labelBtnAdd,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.route?.meta?.permission?.read)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_InputIconRightGrey, {
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
                  placeholder: _ctx.placeholderInputSearch,
                  canClick: true,
                  onSubmitInput: _ctx.searchData,
                  onKeyup: _withKeys(_ctx.searchData, ["enter"]),
                  type: _ctx.enumBase.input.text,
                  icon: _ctx.icon.svg.searchEva
                }, null, 8, ["modelValue", "placeholder", "onSubmitInput", "onKeyup", "type", "icon"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          id: "hjx-data-table",
          value: _ctx.dataSource,
          paginator: false,
          loading: _ctx.isLoading,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll",
          onSort: _ctx.onSort
        }, {
          empty: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            (_ctx.columns.length > 0)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.columns, (col, index) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    key: index,
                    field: col.field,
                    header: col.headerName,
                    hidden: col?.visible,
                    sortable: col.sortable,
                    class: col?.class,
                    style: col?.style,
                    id: `id-${_ctx.nameSlotColumn(col.field)}`
                  }, {
                    body: _withCtx(({ data, field }) => [
                      (_ctx.$slots[_ctx.nameSlotColumn(col.field)])
                        ? _renderSlot(_ctx.$slots, _ctx.nameSlotColumn(col.field), _mergeProps({ key: 0 }, {
                rowData: data,
                field,
                index
              }))
                        : (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.get(data, col.field)), 1))
                    ]),
                    _: 2
                  }, 1032, ["field", "header", "hidden", "sortable", "class", "style", "id"]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "loading", "onSort"])
      ]),
      footer: _withCtx(() => [
        (_ctx.paginate.totalRecords > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.paginate.pageSize,
              totalRecords: _ctx.paginate.totalRecords,
              onPage: _ctx.onChangePage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}